export default {
  'Teklif Formu': '报价单',
  'Kayıtlı Teklifler': '已保存报价',
  'Kullanıcı Adı': '用户名',
  'Şifre': '密码',
  'Giriş Yap': '登录',
  'Çıkış Yap': '退出',
  'KDV Oranı': '增值税税率',
  'Teklif Durumu': '报价状态',
  'Kaydet': '保存',
  'PDF Önizleme': 'PDF预览',
  'PDF\'ye Aktar': '导出为PDF',
  'E-posta ile Gönder': '通过邮件发送',
  'Alıcı': '收件人',
  'Tarih': '日期',
  'Genel Toplam': '总计',
  'Not': '备注',
  'KDV': '增值税',
  'Alt Toplam': '小计',
  'Açıklama': '描述',
  'Ürün Adı': '产品名称',
  'SUT Kodu': 'SUT代码',
  'Birim Alış Fiyatı': '单价',
  'Sipariş Adedi': '订单数量',
  'Promosyon Ürün': '促销产品',
  'Toplam Adet': '总数量',
  'Sipariş Tutarı': '订单金额',
  'Durum': '状态',
  'Kabul Edildi': '已接受',
  'Reddedildi': '已拒绝',
  'Gönderildi': '已发送',
  'Taslak': '草稿',
  'Yurtiçi': '国内',
  'Yurtdışı': '国际',
  'Sipariş Oluştur': '创建订单',
  'Ürün Sıralaması': '产品排序',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': '产品按受欢迎程度和重要性排序',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': '心脏病学和血管外科产品优先显示',
  'Ürün adı, açıklama veya barkod ile ara...': '按产品名称、描述或条形码搜索...',
  'Tüm Kategoriler': '所有类别',
  'Kutu görünüm': '网格视图',
  'Liste görünüm': '列表视图',
  'Aradığınız kriterlere uygun ürün bulunamadı': '未找到符合您条件的产品',
  'Ürün Adı Yok': '无产品名称',
  'Kategori Yok': '无类别',
  'Açıklama yok': '无描述',
  'Firma Bilgilerini Doldurun': '填写公司信息',
  'Sepete Ekle': '添加到购物车',
  'Firma Bilgileri': '公司信息',
  'Ülke Seçimi': '国家选择',
  'Türkiye': '土耳其',
  'Almanya': '德国',
  'ABD': '美国',
  'Firma Ünvanı': '公司名称',
  'Vergi Dairesi': '税务局',
  'Vergi Numarası': '税号',
  'Adres': '地址',
  'Şehir': '城市',
  'Şehir Seçimi': '城市选择',
  'Şehir Seçiniz': '选择城市',
  'Şehir adı ara...': '搜索城市名称...',
  'Aradığınız şehir bulunamadı': '未找到城市',
  'Bu ülke için şehir verisi bulunamadı': '此国家没有城市数据',
  'şehir bulundu': '找到{{count}}个城市',
  'Yetkili': '授权人',
  'Telefon': '电话',
  'Email': '邮箱',
  'Bilgileri İlet': '发送信息',
  'Lütfen eksik alanları doldurun': '请填写缺失的字段',
  'Firma kaydedilemedi': '公司信息未保存',
  'Firma bilgileri başarıyla iletildi': '公司信息发送成功',
  'Firma Ünvanı:': '公司名称:',
  'Yetkili Kişi:': '授权人:',
  'Sepetiniz': '您的购物车',
  'Sepetiniz boş': '您的购物车为空',
  'adet': '件',
  'Düzenle': '编辑',
  'Kaldır': '删除',
  'Siparişi Tamamla': '完成订单',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': '请先完整发送您的公司信息',
  'Sipariş başarıyla kaydedildi': '订单保存成功',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': '欢迎消息和访问链接已发送到您的邮箱',
  'Link 3 gün geçerlidir': '链接有效期为3天',
  'Sipariş kaydedilemedi': '订单未保存',
  'Firma Bilgileri Gerekli': '需要公司信息',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': '请先填写公司信息以添加到购物车',
  'Önce Bilgileri Doldurun': '请先填写信息',
  'Uyarı': '警告',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': '您必须先填写公司信息才能添加到购物车',
  'SUT Kütüphanesi Tanımı': 'SUT库定义',
  'SUT Kodu:': 'SUT代码:',
  'Standart': '标准',
  'Açıklama (isteğe bağlı)': '描述（可选）',
  'Partner Ol': '成为合作伙伴',
  'Partner başvuru popup açılacak': '合作伙伴申请弹窗将打开',
  'Dil': '语言',
  'E-posta': '邮箱',
  'E-Posta': '邮箱',
  'Şifre': '密码',
  'Şifremi Unuttum': '忘记密码',
  'Giriş yapılıyor...': '正在登录...',
  'E-posta veya şifre hatalı': '邮箱或密码错误',
  'Şifre sıfırlama e-postası gönderildi': '密码重置邮件已发送',
  'E-posta gönderilemedi': '邮件未发送',
  'Üye Ol': '注册',
  'Üye Değil Misiniz?': '还不是会员？',
  'Şimdi Üye Ol': '立即注册',
  'Misafir Kullanıcı': '访客用户',
  'Hızlı Sipariş': '快速订单',
  'Misafir Olarak Sipariş Verin': '以访客身份下单',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': '无需登录即可快速选择产品并创建订单',
  'Giriş yapmadan sipariş oluşturun': '无需登录即可创建订单',
  'Anında Erişim': '即时访问',
  'Tüm ürünlere anında erişim': '即时访问所有产品',
  'Güvenli İşlem': '安全交易',
  'SSL korumalı güvenli sipariş': 'SSL保护的安全订单',
  'Misafir Olarak Sipariş Oluştur': '以访客身份创建订单',
  'İpucu:': '提示:',
  'Daha fazla özellik için üye olun': '注册以获得更多功能',
  'Ücretsiz': '免费',
  'Hızlı': '快速',
  'Güvenli': '安全',
  'bayilikSozlesme': '我已阅读并接受INVAMED合作伙伴条款和条件。',
  'geri': '返回',
  'basvuruGonder': '发送申请',
  'ileri': '下一步',
  'sozlesmeGonderildi': '合同已发送到您的邮箱！',
  'sozlesmeDesc': '请上传发送到您邮箱的INVAMED合作伙伴合同和所需文件。',
  'tamamla': '完成申请',
  'basvuruAlindi': '您的申请已收到！',
  'basvuruAlindiDesc': 'INVAMED团队将审查您的申请并尽快与您联系。',
  'Başvuru Durumu': '申请状态',
  'Başvurunuz onay sürecindedir': '您的申请正在审核中',
  'sifreSifirla': '重置密码',
  'sifreSifirlaDesc': '输入您的注册邮箱，我们将发送密码重置说明。',
  'gonder': '发送',
  'talimatGonderildi': '说明已发送',
  'sentDesc': '密码重置说明已发送到 <b>{email}</b>。请检查您的邮箱。',
  'helpTitle': '如何登录？',
  'helpList': [
    '要登录INVAMED经销商面板，请输入您的注册邮箱和密码。',
    '要使用演示用户登录：',
    '如果您忘记密码，请使用"忘记密码"链接申请重置。',
    '如果您有登录问题，请确保您的邮箱和密码正确。如果问题持续存在，请联系我们的支持团队。'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED合作伙伴协议和条款',
  'partnerlikSozlesmeText': `1. 一般规定

本协议由INVAMED（以下简称"公司"）和合作伙伴候选人（以下简称"合作伙伴"）签订，旨在合作销售医疗器械和设备。

2. 合作伙伴条件

2.1. 合作伙伴必须具有销售医疗器械的合法权限。
2.2. 合作伙伴必须是在医疗保健行业运营的组织。
2.3. 合作伙伴必须拥有必要的许可证和证书。
2.4. 合作伙伴必须在财务上可靠。

3. 各方义务

公司义务：
3.1. 提供优质产品和服务
3.2. 提供技术支持
3.3. 提供培训和信息
3.4. 在定价方面保持透明

合作伙伴义务：
3.1. 在适当条件下储存产品
3.2. 提供优质客户服务
3.3. 遵守法律规范
3.4. 保护公司品牌

4. 定价和付款

4.1. 价格由公司确定
4.2. 合作伙伴必须维持确定的价格
4.3. 付款条件另行确定
4.4. 佣金率可能根据业绩而变化

5. 保密和安全

5.1. 各方有义务保护彼此的机密信息
5.2. 客户信息必须保密
5.3. 必须遵守数据安全标准

6. 协议期限和终止

6.1. 本协议有效期为1年
6.2. 可通过相互协议延长
6.3. 可提前30天通知终止
6.4. 在严重违规情况下可立即终止

7. 争议解决

7.1. 争议主要通过谈判解决
7.2. 土耳其共和国法院对未解决案件有管辖权

8. 效力

本协议已由各方阅读、理解并接受。`,
  'partnerlikSozlesmeOnay': '我已阅读、理解并接受上述INVAMED合作伙伴协议和条款。我声明接受本协议的所有条款并将履行我的义务。',
  'sozlesmeyiGoruntule': '查看协议',
  'sozlesmeyiKapat': '关闭',
  'Ürün': '产品',
  'Ürün eklemek için ürün listesinden seçim yapın': '从产品列表中选择以添加到购物车',
  'Etiketler': '标签',
  'Öncelikli': '优先',
  'Kapat': '关闭',
  'globalPartnersTitle': '与全球30,000个合作伙伴合作',
  'globalPartnersDesc': '我们庞大的30,000个合作伙伴全球网络推动共享创新、知识交流和互利成功。通过共同努力，我们不断扩大患者护理的边界。',
  'Yardım': '帮助',
  'dil': '语言',
  'Connect Free!': '免费连接！',
  'En çok tercih edilen ürünlerimizi keşfedin': '探索我们最受欢迎的产品',
  '48 ürün gösteriliyor (Toplam: 8000+)': '显示48个产品（总计：8000+）',
  'Tüm Ürünleri Gör →': '查看所有产品 →',
  'Detaylar': '详情',
  'Sipariş Ver': '立即订购',
  'Giriş Yap': '登录',
  'Hesabınıza giriş yapın': '登录您的账户',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': '此网站受reCAPTCHA保护，并适用Google隐私政策和服务条款。',
  'Ürün Kataloğumuz': '我们的产品目录',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': '我们提供8000多种产品',
  '1,3B': '1.3千',
  'Partner': '合作伙伴',
  '8,4M': '840万',
  'Toplam Üretim': '总产量',
  '23': '23',
  'Branş': '分支机构',
  '27,5B': '27.5千',
  'Toplam Sipariş': '总订单',
  'Connect Now': '立即连接',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': '免费注册，在一个地方访问所有信息。',
  'Ürün Detayları': '产品详情',
  'Kapat': '关闭',
  'Yükleniyor...': '加载中...',
  'Hata': '错误',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '显示{{count}}个产品（总计：8000+）',
  'Şehir Seçimi': '城市选择',
  'Firma / Sağlık Profesyoneli': '公司 / 医疗专业人员',
  'Yetkili Kişi': '授权人员',
  'Telefon': '电话',
  'E-posta': '电子邮件',
  'Temel Bilgiler': '基本信息',
  'Ek Bilgiler': '附加信息',
  'Faaliyet Alanı / Sektör': '活动领域 / 行业',
  'Ülke Seçimi': '国家选择',
  'Ülke adı veya kodu ara...': '搜索国家名称或代码...',
  'region.Avrupa': '欧洲',
  'region.Amerika': '美洲',
  'region.Asya': '亚洲',
  'region.Afrika': '非洲',
  'region.Okyanusya': '大洋洲',
  'region.Diğer': '其他',
  'country.TR': '土耳其',
  'country.US': '美国',
  'country.DE': '德国',
  'country.FR': '法国',
  'country.GB': '英国',
  'country.IT': '意大利',
  'country.ES': '西班牙',
  'country.RU': '俄罗斯',
  'country.CN': '中国',
  'country.JP': '日本',
  'country.KR': '韩国',
  'country.IN': '印度',
  'country.BR': '巴西',
  'country.CA': '加拿大',
  'country.AU': '澳大利亚',
  'Ticaret Sicil No': '商业登记号',

  'country.TR': '土耳其',
  'country.AL': '阿尔巴尼亚',
  'country.DE': '德国',
  'country.AD': '安道尔',
  'country.AT': '奥地利',
  'country.BY': '白俄罗斯',
  'country.BE': '比利时',
  'country.BA': '波斯尼亚和黑塞哥维那',
  'country.BG': '保加利亚',
  'country.CZ': '捷克共和国',
  'country.DK': '丹麦',
  'country.EE': '爱沙尼亚',
  'country.FO': '法罗群岛',
  'country.FI': '芬兰',
  'country.FR': '法国',
  'country.GI': '直布罗陀',
  'country.GR': '希腊',
  'country.GG': '根西岛',
  'country.HR': '克罗地亚',
  'country.NL': '荷兰',
  'country.IE': '爱尔兰',
  'country.ES': '西班牙',
  'country.SE': '瑞典',
  'country.CH': '瑞士',
  'country.IT': '意大利',
  'country.IS': '冰岛',
  'country.JE': '泽西岛',
  'country.ME': '黑山',
  'country.LV': '拉脱维亚',
  'country.LI': '列支敦士登',
  'country.LT': '立陶宛',
  'country.LU': '卢森堡',
  'country.HU': '匈牙利',
  'country.MT': '马耳他',
  'country.IM': '马恩岛',
  'country.MD': '摩尔多瓦',
  'country.MC': '摩纳哥',
  'country.MK': '北马其顿',
  'country.NO': '挪威',
  'country.PL': '波兰',
  'country.PT': '葡萄牙',
  'country.RO': '罗马尼亚',
  'country.RU': '俄罗斯',
  'country.SM': '圣马力诺',
  'country.RS': '塞尔维亚',
  'country.SK': '斯洛伐克',
  'country.SI': '斯洛文尼亚',
  'country.SJ': '斯瓦尔巴和扬马延',
  'country.UA': '乌克兰',
  'country.GB': '英国',
  'country.VA': '梵蒂冈',
  'country.AX': '奥兰群岛',
  'country.US': '美国',
  'country.AS': '美属萨摩亚',
  'country.AI': '安圭拉',
  'country.AG': '安提瓜和巴布达',
  'country.AR': '阿根廷',
  'country.AW': '阿鲁巴',
  'country.BS': '巴哈马',
  'country.BB': '巴巴多斯',
  'country.BZ': '伯利兹',
  'country.BM': '百慕大',
  'country.BO': '玻利维亚',
  'country.BR': '巴西',
  'country.VG': '英属维尔京群岛',
  'country.CA': '加拿大',
  'country.KY': '开曼群岛',
  'country.CL': '智利',
  'country.CO': '哥伦比亚',
  'country.CR': '哥斯达黎加',
  'country.CU': '古巴',
  'country.CW': '库拉索',
  'country.DM': '多米尼克',
  'country.DO': '多米尼加共和国',
  'country.EC': '厄瓜多尔',
  'country.SV': '萨尔瓦多',
  'country.FK': '福克兰群岛',
  'country.GF': '法属圭亚那',
  'country.GD': '格林纳达',
  'country.GL': '格陵兰',
  'country.GP': '瓜德罗普',
  'country.GT': '危地马拉',
  'country.GY': '圭亚那',
  'country.HT': '海地',
  'country.HN': '洪都拉斯',
  'country.JM': '牙买加',
  'country.MQ': '马提尼克',
  'country.MX': '墨西哥',
  'country.MS': '蒙特塞拉特',
  'country.NI': '尼加拉瓜',
  'country.PA': '巴拿马',
  'country.PY': '巴拉圭',
  'country.PE': '秘鲁',
  'country.PR': '波多黎各',
  'country.BL': '圣巴泰勒米',
  'country.KN': '圣基茨和尼维斯',
  'country.LC': '圣卢西亚',
  'country.MF': '圣马丁',
  'country.PM': '圣皮埃尔和密克隆',
  'country.VC': '圣文森特和格林纳丁斯',
  'country.SX': '圣马丁',
  'country.SR': '苏里南',
  'country.TT': '特立尼达和多巴哥',
  'country.TC': '特克斯和凯科斯群岛',
  'country.UY': '乌拉圭',
  'country.VE': '委内瑞拉',
  'country.VI': '美属维尔京群岛',
  'country.AF': '阿富汗',
  'country.AZ': '阿塞拜疆',
  'country.BH': '巴林',
  'country.BD': '孟加拉国',
  'country.AE': '阿拉伯联合酋长国',
  'country.BN': '文莱',
  'country.BT': '不丹',
  'country.CN': '中国',
  'country.TL': '东帝汶',
  'country.ID': '印度尼西亚',
  'country.AM': '亚美尼亚',
  'country.PH': '菲律宾',
  'country.PS': '巴勒斯坦',
  'country.GE': '格鲁吉亚',
  'country.KR': '韩国',
  'country.IN': '印度',
  'country.HK': '香港',
  'country.IQ': '伊拉克',
  'country.IR': '伊朗',
  'country.IL': '以色列',
  'country.JP': '日本',
  'country.KH': '柬埔寨',
  'country.QA': '卡塔尔',
  'country.KZ': '哈萨克斯坦',
  'country.KG': '吉尔吉斯斯坦',
  'country.CY': '塞浦路斯',
  'country.KW': '科威特',
  'country.KP': '朝鲜',
  'country.LA': '老挝',
  'country.LB': '黎巴嫩',
  'country.MO': '澳门',
  'country.MV': '马尔代夫',
  'country.MY': '马来西亚',
  'country.MM': '缅甸',
  'country.MN': '蒙古',
  'country.NP': '尼泊尔',
  'country.UZ': '乌兹别克斯坦',
  'country.PK': '巴基斯坦',
  'country.SG': '新加坡',
  'country.LK': '斯里兰卡',
  'country.SY': '叙利亚',
  'country.SA': '沙特阿拉伯',
  'country.TJ': '塔吉克斯坦',
  'country.TH': '泰国',
  'country.TW': '台湾',
  'country.TM': '土库曼斯坦',
  'country.OM': '阿曼',
  'country.JO': '约旦',
  'country.VN': '越南',
  'country.YE': '也门',
  'country.DZ': '阿尔及利亚',
  'country.AO': '安哥拉',
  'country.BJ': '贝宁',
  'country.BW': '博茨瓦纳',
  'country.BF': '布基纳法索',
  'country.BI': '布隆迪',
  'country.CV': '佛得角',
  'country.CM': '喀麦隆',
  'country.CF': '中非共和国',
  'country.TD': '乍得',
  'country.KM': '科摩罗',
  'country.CG': '刚果共和国',
  'country.CD': '刚果民主共和国',
  'country.CI': '科特迪瓦',
  'country.DJ': '吉布提',
  'country.EG': '埃及',
  'country.GQ': '赤道几内亚',
  'country.ER': '厄立特里亚',
  'country.SZ': '斯威士兰',
  'country.ET': '埃塞俄比亚',
  'country.GA': '加蓬',
  'country.GM': '冈比亚',
  'country.GH': '加纳',
  'country.GN': '几内亚',
  'country.GW': '几内亚比绍',
  'country.KE': '肯尼亚',
  'country.LS': '莱索托',
  'country.LR': '利比里亚',
  'country.LY': '利比亚',
  'country.MG': '马达加斯加',
  'country.MW': '马拉维',
  'country.ML': '马里',
  'country.MR': '毛里塔尼亚',
  'country.MU': '毛里求斯',
  'country.YT': '马约特',
  'country.MA': '摩洛哥',
  'country.MZ': '莫桑比克',
  'country.NA': '纳米比亚',
  'country.NE': '尼日尔',
  'country.NG': '尼日利亚',
  'country.RE': '留尼汪',
  'country.RW': '卢旺达',
  'country.SH': '圣赫勒拿',
  'country.ST': '圣多美和普林西比',
  'country.SN': '塞内加尔',
  'country.SC': '塞舌尔',
  'country.SL': '塞拉利昂',
  'country.SO': '索马里',
  'country.ZA': '南非',
  'country.SS': '南苏丹',
  'country.SD': '苏丹',
  'country.TZ': '坦桑尼亚',
  'country.TG': '多哥',
  'country.TN': '突尼斯',
  'country.UG': '乌干达',
  'country.EH': '西撒哈拉',
  'country.ZM': '赞比亚',
  'country.ZW': '津巴布韦',
  'country.AU': '澳大利亚',
  'country.CX': '圣诞岛',
  'country.CC': '科科斯群岛',
  'country.CK': '库克群岛',
  'country.FJ': '斐济',
  'country.PF': '法属波利尼西亚',
  'country.GU': '关岛',
  'country.HM': '赫德岛和麦克唐纳群岛',
  'country.KI': '基里巴斯',
  'country.MH': '马绍尔群岛',
  'country.FM': '密克罗尼西亚',
  'country.NR': '瑙鲁',
  'country.NC': '新喀里多尼亚',
  'country.NZ': '新西兰',
  'country.NU': '纽埃',
  'country.NF': '诺福克岛',
  'country.MP': '北马里亚纳群岛',
  'country.PW': '帕劳',
  'country.PG': '巴布亚新几内亚',
  'country.PN': '皮特凯恩群岛',
  'country.WS': '萨摩亚',
  'country.SB': '所罗门群岛',
  'country.TK': '托克劳',
  'country.TO': '汤加',
  'country.TV': '图瓦卢',
  'country.VU': '瓦努阿图',
  'country.WF': '瓦利斯和富图纳',
  'country.AQ': '南极洲',
  'country.BV': '布韦岛',
  'country.IO': '英属印度洋领地',
  'country.TF': '法属南部领地',
  'country.GS': '南乔治亚和南桑威奇群岛',
};
